import AuthService from "../../AuthService";
const utility = {
  getPathImage(data) {
    return AuthService.post("/upload_image", data);
  },
  getPathFile(data) {
    return AuthService.post("/upload_file", data);
  },
  getImageFilePath(data) {
    return AuthService.post("/get-file-path", data);
  },
  getUploadFilesPath(data) {
    return AuthService.post("/get-upload-files-path", data);
  }
};
export default utility;
